import { AnalyticsService } from '../analytics';

export const analyticsService = new AnalyticsService();
